import * as React from 'react';

import {
  Colors,

  useDimensions,

  Text,
  Icon,
} from '@bluecurrent/web-component-lib';

export default function StepByStepItem({
  text,
  icon,
  onPress,
}) {
  const size = useDimensions();

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      style={{
        height: 'auto',
        aspectRatio: '1/1',
        backgroundColor: Colors.LIGHT_GREY,
        padding: 25,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        gap: 15,
        gridColumn: size.width < 500 ? 'span 12' : size.width < 830 ? 'span 6' : 'span 4',
        gridRow: size.width < 500 ? 'span 12' : size.width < 830 ? 'span 6' : 'span 4',
        position: 'relative',
        cursor: onPress && 'pointer',
      }}
      onClick={() => onPress && onPress()}
    >
      <Icon
        name={icon}
        height={60}
        width={60}
        color={Colors.BLUE}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <Text
          textAlign="center"
          lineHeight={1.3}
          color={onPress && Colors.BLUE}
        >
          {text}
        </Text>
      </div>
    </div>
  );
}
